import { Box } from '@mui/material';
// import { useTheme } from '@mui/material/styles';

const LogoComete = ({ ...other }) => (
  // const theme = useTheme();
  // const PRIMARY_MAIN = theme.palette.primary.main;
  // const PRIMARY_DARK = theme.palette.primary.dark;

  <Box component="span" display="block" {...other}>
    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M35.8354 15.1343L0.5 0.5L15.9226 36.0405C18.4605 41.8146 24.122 45.5976 30.2715 45.4981C38.8614 45.3985 45.5966 38.2307 45.499 29.47C45.4013 23.0986 41.5945 17.4241 35.8354 15.1343ZM30.4668 40.5204C26.3671 40.62 22.7554 38.1311 21.0961 34.3481L11.0421 11.1522L34.0784 20.7093C37.8853 22.3022 40.3255 25.9856 40.4232 30.0673C40.5208 35.7419 36.1282 40.4209 30.4668 40.5204Z"
        fill="url(#paint0_radial_545_1654)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_545_1654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.6786 15.1168) scale(62.2203 63.4579)"
        >
          <stop stopColor="#FEEB17" />
          <stop offset="0.7358" stopColor="#F8BF01" />
        </radialGradient>
      </defs>
    </svg>
  </Box>
);

export default LogoComete;
